// extracted by mini-css-extract-plugin
export default {"tasks":"hN-z","task":"iN-z","svg":"jN-z","text":"kN-z"};